import posthog from "posthog-js";

/** Connect funnel surfaces — packet telegram-connect-adoption D4. */
export type TelegramConnectSurface = "onboarding" | "homepage" | "profile";

export type TelegramConnectLinkFailReason =
  | "not_configured"
  | "unauthorized"
  | "no_session"
  | "request_failed"
  | "network";

export type TelegramNearMeOptInMethod = "toggle" | "auto_link";

export const TELEGRAM_CONNECT_PANEL_VIEWED =
  "telegram_connect_panel_viewed" as const;
export const TELEGRAM_CONNECT_CLICKED = "telegram_connect_clicked" as const;
export const TELEGRAM_CONNECT_LINK_READY =
  "telegram_connect_link_ready" as const;
export const TELEGRAM_CONNECT_LINK_FAILED =
  "telegram_connect_link_failed" as const;
export const TELEGRAM_CONNECTED = "telegram_connected" as const;
export const TELEGRAM_NEAR_ME_OPTED_IN = "telegram_near_me_opted_in" as const;

function capture(event: string, properties: Record<string, unknown>): void {
  try {
    posthog.capture(event, properties);
  } catch (error) {
    console.warn(`[posthog] ${event} capture failed:`, error);
  }
}

/** Map user-link HTTP failures to a stable, non-secret reason enum. */
export function telegramConnectLinkFailReasonFromResponse(params: {
  status: number;
  hasSession: boolean;
}): TelegramConnectLinkFailReason {
  if (!params.hasSession) return "no_session";
  if (params.status === 503) return "not_configured";
  if (params.status === 401 || params.status === 403) return "unauthorized";
  return "request_failed";
}

export function captureTelegramConnectPanelViewed(
  surface: TelegramConnectSurface,
): void {
  capture(TELEGRAM_CONNECT_PANEL_VIEWED, { surface });
}

export function captureTelegramConnectClicked(
  surface: TelegramConnectSurface,
): void {
  capture(TELEGRAM_CONNECT_CLICKED, { surface });
}

export function captureTelegramConnectLinkReady(
  surface: TelegramConnectSurface,
): void {
  capture(TELEGRAM_CONNECT_LINK_READY, { surface });
}

export function captureTelegramConnectLinkFailed(params: {
  surface: TelegramConnectSurface;
  reason: TelegramConnectLinkFailReason;
}): void {
  capture(TELEGRAM_CONNECT_LINK_FAILED, {
    surface: params.surface,
    reason: params.reason,
  });
}

export function captureTelegramConnected(params: {
  surface?: TelegramConnectSurface;
}): void {
  capture(
    TELEGRAM_CONNECTED,
    params.surface ? { surface: params.surface } : {},
  );
}

export function captureTelegramNearMeOptedIn(params: {
  surface: TelegramConnectSurface;
  method: TelegramNearMeOptInMethod;
}): void {
  capture(TELEGRAM_NEAR_ME_OPTED_IN, {
    surface: params.surface,
    method: params.method,
  });
}
